import classNames from 'classnames';
import { forwardRef } from 'react';

import Box, { BoxProps } from '../Box';

/**
 * @deprecated Use Box instead with display="flex"
 */
const Flex = forwardRef<HTMLElement, BoxProps>((props, ref) => (
  <Box
    alignItems="center"
    display="flex"
    {...props}
    className={classNames(props.className, 'flex')}
    ref={ref}
  />
));

export default Flex;
